if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      /* backdrop-tap close — 2026-08-03 */
      // Base ModalDialog only closes a .media-modal on pointerup when pointerType is
      // "mouse", so touch users have no dismiss path except the X. Close on a tap whose
      // target is the dialog/content backdrop itself — never the media or a control.
      // The `open` guard makes this a no-op on desktop, where the base pointerup handler
      // has already closed the modal before `click` fires.
      this.addEventListener('click', (event) => {
        if (!this.hasAttribute('open')) return;
        const target = event.target;
        if (
          target === this ||
          target.classList.contains('product-media-modal__dialog') ||
          target.classList.contains('product-media-modal__content')
        ) {
          this.hide();
        }
      });

      /* image-tap advances to the next photo (mobile) — 2026-08-03 */
      // Below 750px base.css shows only the .active child of the modal content, and
      // showActiveMedia() sets .active once at open time and never again — so the
      // lightbox is a single frozen image with no swipe and no zoom, while the gallery
      // behind it swipes. Clarity recordings show users tapping the image repeatedly
      // expecting it to respond. Advance on tap so every tap does something visible.
      //
      // Registered after the backdrop-close listener above; the two are mutually
      // exclusive (that one fires only on the dialog/content backdrop, this one only on
      // an <img>), so both can run on the same click without conflicting.
      // Tapping the left third goes back, the rest goes forward — centre taps advance,
      // which is what the recordings show users reaching for.
      this.addEventListener('click', (event) => {
        if (!this.hasAttribute('open')) return;
        // Desktop stacks every media item and the base pointerup handler already closed
        // the modal before `click` fires; advancing there would be meaningless.
        if (window.matchMedia('(min-width: 750px)').matches) return;
        const target = event.target;
        if (target.tagName !== 'IMG') return;
        if (target.closest('deferred-media, product-model')) return;
        if (!target.closest('.product-media-modal__content')) return;
        const bounds = target.getBoundingClientRect();
        const direction = event.clientX - bounds.left < bounds.width / 3 ? -1 : 1;
        this.advanceMedia(direction);
      });
    }

    hide() {
      super.hide();
    }

    advanceMedia(direction = 1) {
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return;

      // Re-read the children every time: VariantSelects.updateMedia() prepends the
      // current variant's featured media on each variant change, so order is not stable.
      const children = Array.from(content.children);

      // Mirror the CSS. With hide_variants on, variant-attached media carries
      // .product__media-item--variant, which base.css hides via a doubled-class rule
      // that outranks .active — it only renders while it is :first-child. Advancing onto
      // one of the others would land on a display:none element and look dead again.
      const shown = children.filter(
        (element, index) => index === 0 || !element.classList.contains('product__media-item--variant')
      );
      if (shown.length < 2) return;

      // + shown.length keeps the modulo positive when stepping back from the first item.
      const current = shown.findIndex((element) => element.classList.contains('active'));
      const next = shown[(current + direction + shown.length) % shown.length];

      children.forEach((element) => element.classList.remove('active'));
      next.classList.add('active');
      content.scrollTop = 0;
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
